import dayjs, { Dayjs } from 'dayjs';
import { z } from 'zod';

export const DayJsFromString = z.string()
  .transform((val) => dayjs(val));
